import styled from "styled-components";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  gap: 88px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px;
  }

   @media (min-width: 1200px){
    gap:120px
  }

  @media (min-width: 1440px){
    padding: 48px 120px;
  }
`;

export const SideCol = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: 1fr;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  /* não use space-between em grid, ele encolhe a grade */
  justify-items: stretch;
  justify-content: space-between;

  @media (min-width: 850px){
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
    gap: 48px;
    align-items: start;
  }
`;

export const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;
  height: 100%;
  justify-content: center;

  h4{
    margin: 0;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 1px;
    text-transform: capitalize;

    @media (min-width: 850px){
      font-size: 32px;
      line-height: 40px;
      letter-spacing: 1px;
    }
  }

  p{
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const RightCol = styled.div`
  /* tokens por breakpoint */
  --gap: 16px;
  --tallH: 328px;  /* ALTURA DESEJADA DA PEÇA ALTA no mobile (ex.: 2*156 + 16) */

  display: grid;
  gap: var(--gap);
  grid-template-columns: 1fr 1fr;

  /* duas linhas iguais: cada uma = (alturaAlta - gap)/2 */
  grid-template-rows:
    calc((var(--tallH) - var(--gap)) / 2)
    calc((var(--tallH) - var(--gap)) / 2);

  /* layout fixo: a b / c b  */
  grid-template-areas:
    "a b"
    "c b";

  align-content: start;
  justify-items: stretch;

  /* LARGURAS: mantenha se quiser limitar o bloco no desktop */
  max-width: 570px;   /* opcional */
  /* REMOVER max-height para não “cortar” o grid */
  /* max-height: none; */

  margin: 0 auto;
  width: 100%;

  @media (min-width: 768px){
    --gap: 32px;
    --tallH: 572px;   /* sua peça alta no tablet */
  }

  @media (min-width: 850px){
    margin: 0;
  }

  @media (min-width: 1200px){
    --gap: 48px;
    --tallH: 570px;   /* sua peça alta no desktop */
  }

  /* mapeamento das imagens */
  & > :nth-child(1) { grid-area: a; } /* pequena topo/esq */
  & > :nth-child(2) { grid-area: c; } /* pequena baixo/esq */
  & > :nth-child(3) { grid-area: b; } /* alta direita (2 linhas) */
`;

export const Tile = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  border-radius: 16px;
  min-width: 0;
  min-height: 0;
`;

export const CardsBox = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr; 
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 768px) {
  grid-template-columns: repeat(2, minmax(0, 1fr));  /* 2 colunas iguais */
  align-items: stretch;            /* trilhas com mesma altura */
  }
`

export const Card = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  padding: 16px;
  gap: 16px;
  opacity: 1;
  background-color: var(--color-0a1323);

  h4{
    font-weight: 700;
    font-style: Bold;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 1px;
  }

  p{
    font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0px;
  }
`
export const TopShadow = styled.div`
  display: none;

  @media (min-width: 1200px){
    width: 100%;
    max-width: 1200px;
    display: block;
    height: 100px;
    border-radius: 68px 68px 0 0;
    z-index: 0;

    background: linear-gradient(180deg, #001339 0%, #001234 100%);

    -webkit-mask-image: linear-gradient(to bottom,
      rgba(0,0,0,1) 0%,
      rgba(0,0,0,.9) 0%,
      rgba(0,0,0,0) 80%);
    
    mask-image: linear-gradient(to bottom,
      rgba(0,0,0,1) 0%,
      rgba(0,0,0,.9) 0%,
      rgba(0,0,0,0) 80%);

    box-shadow:
      inset 0 20px 40px rgba(0,0,0,0.35),
      0 6px 20px rgba(0,0,0,0.25);
  }
`;

export const PartnersSection = styled.section`
  max-width: 1200px;
  width: 100%;
  margin:0 auto;
  padding: 0 16px;
`;

export const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const PartnerCard = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: left;
  border-radius: 12px;
  border-radius: 6px;
  gap: 8px;
`;

export const Photo = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  margin-bottom: 10px;
`;

export const ShadowPhoto = styled.div`
  display: none;
  position: absolute;
  left: 50%;
  bottom:50px ;
  transform: translateX(-50%);
  width: min(72%, 560px);        /* largura do halo */
  height: 64px;                  /* altura do halo */
  pointer-events: none;
  z-index: 0;

  /* halo elíptico com centro no topo, desvanecendo pra baixo/lados */
  background:
    radial-gradient(60% 220% at 50% 0%,
      rgba(0, 83, 241, 0.65) 0%,
      rgba(0, 83, 241, 0.30) 35%,
      rgba(0, 83, 241, 0.14) 55%,
      rgba(0, 83, 241, 0.00) 75%
    );

  filter: blur(20px);
  opacity: 0.9;

   @media (min-width:641px){
    display: block;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Name = styled.p`
  font-weight: 700;
  font-style: Bold;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 1px;
`;

export const Job = styled.span`
  font-weight: 400;
  font-style: Regular;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 1px;
`;